import React, { useEffect, useState } from "react";
import { 
  Button,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import {
  LockOutlined,
  GroupsOutlined,
  PersonOutlineOutlined
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import "./UserProfileSidebar.css";
import { GroupResponseDto, ProfileDto } from "../types/authTypes";
import { getMyGroups, getProfile } from "../service/authApi";
import { LogOut } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";

function UserprofileSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const {logout}=useAuth();
  const [gruop, setGroup] = useState<GroupResponseDto>({
    freeGroupLimit: 0,
    joinedGroupCount: 0,
    remainingFreeGroups: 0,
    groups: [],
  });
  
  useEffect(() => {
    loadGroups();
  }, []);
  
  const loadGroups = async () => {
    try {
      const response = await getMyGroups();
      setGroup(response);
    } catch (error) {
      console.error(error);
    }
  };

  const [profile, setProfile] =
          useState<ProfileDto>();
          // eslint-disable-next-line
          const [loading, setLoading] = useState(true);

             useEffect(() => {
          
                  loadProfile();
          
              }, []);
          
              const loadProfile = async () => {
          
                  try {
          
                      const response =
                          await getProfile();
          
                      setProfile(response);
          
                  }
                  finally {
          
                      setLoading(false);
          
                  }
          
              };

               const handleLogout = () => {

        logout();

        navigate("/login");

    };

  const menus = [
    {
      title: "Profile",
      icon: <PersonOutlineOutlined />,
      path: "/user/profile",
    },
    {
      title: "Change Password",
      icon: <LockOutlined />,
      path: "/user/change-password",
    },
    {
      title: "My Groups",
      icon: <GroupsOutlined />,
      path: "/user/mygroup",
    },
    
  ];

  return (
   <div
  className="profile-sidebar"
  style={{
    width: "100%",
    minHeight: "100vh",
    background: "linear-gradient(180deg,#0f172a,#1e40af,#2563eb)",
    color: "#fff",
    padding: "25px 18px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 12px 35px rgba(0,0,0,.25)",
  }}
>
  {/* Profile Header */}

  <div
    style={{
      textAlign: "center",
      marginBottom: 30,
    }}
  >
    <div
      style={{
        width: 85,
        height: 85,
        borderRadius: "50%",
        background: "rgba(255,255,255,.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        border: "3px solid rgba(255,255,255,.25)",
        fontSize: 34,
        fontWeight: 700,
      }}
    >
      {profile?.name?.charAt(0)}
    </div>

    <h4
      style={{
        marginTop: 18,
        marginBottom: 4,
        fontWeight: 700,
      }}
    >
      My Account
    </h4>

    <small
      style={{
        color: "#dbeafe",
      }}
    >
      Manage your profile & groups
    </small>
  </div>

  {/* Menu */}

  <Nav vertical>
    {menus.map((menu) => {
      const active = location.pathname === menu.path;

      return (
       <>
        <NavItem
          key={menu.path}
          style={{
            marginBottom: 14,
          }}
        >
          <NavLink
            href=""
            onClick={(e) => {
              e.preventDefault();
              navigate(menu.path);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: "14px 18px",
              borderRadius: 15,
              textDecoration: "none",
              transition: ".3s",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 16,

              background: active
                ? "#ffffff"
                : "rgba(255,255,255,.10)",

              color: active ? "#1e3a8a" : "#fff",

              boxShadow: active
                ? "0 10px 20px rgba(0,0,0,.15)"
                : "none",
            }}
            onMouseEnter={(e) => {
              if (!active)
                e.currentTarget.style.background =
                  "rgba(255,255,255,.18)";
            }}
            onMouseLeave={(e) => {
              if (!active)
                e.currentTarget.style.background =
                  "rgba(255,255,255,.10)";
            }}
          >
            {menu.icon}
            {menu.title}
          </NavLink>
        </NavItem>

       
       
       </>

      );
    })}
 
 


 
  </Nav>

  {/* Statistics */}

  <div style={{ marginTop: "25px" }}>
    <h6
      style={{
        marginBottom: 15,
        color: "#dbeafe",
        fontWeight: 600,
      }}
    >
      Group Statistics
    </h6>

    {/* Free */}

    <div
      style={{
        background: "rgba(255,255,255,.12)",
        borderRadius: 15,
        padding: 15,
        marginBottom: 12,
      }}
    >
      <small style={{ color: "#bfdbfe" }}>
        Free Group Limit
      </small>

      <h3
        style={{
          margin: 0,
          fontWeight: 700,
        }}
      >
        {gruop.freeGroupLimit}
      </h3>
    </div>

    {/* Joined */}

    <div
      style={{
        background: "rgba(16,185,129,.20)",
        borderRadius: 15,
        padding: 15,
        marginBottom: 12,
      }}
    >
      <small style={{ color: "#bbf7d0" }}>
        Joined Groups
      </small>

      <h3
        style={{
          margin: 0,
          fontWeight: 700,
        }}
      >
        {gruop.joinedGroupCount}
      </h3>
    </div>

    {/* Remaining */}

    <div
      style={{
        background: "rgba(16,185,129,.20)",
        borderRadius: 15,
        padding: 15,
      }}
    >
      <small style={{ color: "#bbf7d0" }}>
        Remaining Groups
      </small>

      <h3
        style={{
          margin: 0,
          fontWeight: 700,
        }}
      >
        {gruop.remainingFreeGroups}
      </h3>
    </div>
  </div>


  <Button color="light" className="mt-4" onClick={handleLogout} style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              padding: "14px 18px",
              borderRadius: 15,
              textDecoration: "none",
              transition: ".3s",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 16,


            
            }}>
<LogOut/> Logout

</Button>
</div>
  );
}

export default UserprofileSidebar;